import { Span, Button } from '@pandiafi/design-system'
import { Formik, Field, FieldProps, Form } from 'formik'
import { t } from 'i18next'
import React from 'react'

import {
  setVerificationCodeInputSchema,
  SetVerificationCodeRequest,
} from '../../../common/validations'

import FormFieldWrapper from 'components/FormField'
import { PinCodeTextInput } from 'views/Register/PinCodeTextInput'
import { validateFormValues } from 'utils'

export const VerifyPasswordCodeForm: React.FC<{
  email: string
  onSubmit: (resetCode: string) => void
}> = ({ onSubmit, email }) => {
  const handleValidate = (formValues: SetVerificationCodeRequest) => {
    const validationErrors = validateFormValues(
      formValues,
      setVerificationCodeInputSchema
    )

    return validationErrors
  }

  const handleSubmit = (values: SetVerificationCodeRequest) => {
    onSubmit(values.verificationCode)
  }

  return (
    <Formik
      initialValues={{ verificationCode: '', email }}
      onSubmit={handleSubmit}
      validate={handleValidate}
      validateOnMount
    >
      {({ isSubmitting, isValid }) => (
        <Form className="flex flex-col gap-5">
          <div className="flex flex-col gap-5">
            <Span light>{t('managePassword:resetCodeSent')}</Span>
            <Span light>{t('managePassword:resetCodeSent2')}</Span>
          </div>

          <Field name="verificationCode">
            {({
              field,
              meta,
            }: FieldProps<SetVerificationCodeRequest['verificationCode']>) => (
              <FormFieldWrapper
                className="flex flex-col items-center !text-center"
                name={field.name}
                meta={meta}
                label={t('managePassword:resetCodeInputLabel')}
                required
              >
                <PinCodeTextInput
                  {...field}
                  disabled={isSubmitting}
                  name="verificationCode"
                />
              </FormFieldWrapper>
            )}
          </Field>

          <Button
            type="submit"
            loading={isSubmitting}
            disabled={!isValid || isSubmitting}
          >
            {t('managePassword:resetCodeSubmitButtonText')}
          </Button>
        </Form>
      )}
    </Formik>
  )
}
